import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateGroupPayload } from '@app-store/slices/group/create'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ICreateGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.group.create
const { onAddGroup } = rootActions.group.list

function* createGroupSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/group`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(onAddGroup(response.result))
            yield payload.sagaCB?.onSuccess()
            notification.success({
                message: 'Group created successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createGroupSagaTask)
}

export default createGroupSaga
